import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from './img/logo.png';

function Header({ hideLoginButton }) {
  const [sidebar, setSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  const toggleSidebar = () => setSidebar(!sidebar);

  const updateMedia = () => {
    setIsMobile(window.innerWidth <= 768);
    if (window.innerWidth > 768) {
      setSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  const isAdminPage = location.pathname.includes('/addjob');
  const isLoginPage = location.pathname.includes('/login');
  const iserrorPage = location.pathname.includes('/error');

  return (
    <>
      <header>
      {!isAdminPage && !isLoginPage && !iserrorPage && (
        <div className="header">
        <div className="navbr">
          {isMobile && (
            <div className="toggle_btn" onClick={toggleSidebar}>
              &#9776; {/* Hamburger icon */}
            </div>
          )}
          <div className="Link22">
            <Link style={{textDecoration:'none',outline:"none"}} to="/" id='span1'><img src={logo} alt="" />
            <span><span style={{color:'#035096 ', fontFamily:"poppins",fontWeight:'600'}}>Better</span><span style={{color:'#e30022'}}> Job Placement </span></span></Link>
          </div>
          {!isMobile && (
            <div className="links">
              <ul>
                <li><a href="/" >Home</a></li>
                <li><a href="/error">Services</a></li>
                <li><a href="/error">About</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
          )}
            <div className="btn">
              <Link to="/login">
                <button className='Login'>Login</button>
              </Link>
            </div>
        </div>
        </div>
      )}
      </header>

      <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
        <ul className="nav-menu-items" onClick={toggleSidebar}>
          <li className="navbar-toggle">
            <div className="menu-bars">
              &#10006; {/* Close icon */}
            </div>
          </li>
          <li><a href="/">Home</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="/contact">Contact</a></li>
          {!isAdminPage && !isLoginPage && (
            <li><Link to="/login" className='Login'>Login</Link></li>
          )}
        </ul>
      </nav>
    </>
  );
}

export default Header;
